(() => {
  const ROOT_SEL = ".ea-sticky-cart";
  const INSERT_BEFORE_SEL = ".eascRecoRow.eascRecoRowBox";
  const SRC_SEL = ".easc-miniCartSubtotalDivInnerDiscounts .easc-discCodeName";

  const ID = "ea-discount-split-outside";
  const WRAP_CLASS = "ea-discount-split";
  const LEFT_CLASS = "ea-discount-split__left";
  const ICON_CLASS = "ea-discount-split__icon"; // NEW
  const RIGHT_CLASS = "ea-discount-split__right";

  const esc = (s) =>
    String(s ?? "").replace(/[&<>"']/g, (c) => ({
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    }[c]));

  const norm = (s) =>
    String(s || "").replace(/\u00A0/g, " ").replace(/\s+/g, " ").trim();

  const deParenS = (s) => String(s || "").replace(/\(\s*s\s*\)/gi, "s");

  const detectLang = (t) => {
    const s = " " + deParenS(t).toLowerCase() + " ";
    if (/(^|\s)(rabat|zniżk|przedmiot|koszyk|dodaj|gratulacje)(\s|$)/i.test(s)) return "pl";
    if (/(^|\s)(rabatt|warenkorb|artikel|hinzu|glückwunsch|gratulation)(\s|$)/i.test(s)) return "de";
    if (/(^|\s)(discount|cart|add|item|congrat)(\s|$)/i.test(s)) return "en";
    if (/(^|\s)(descuento|carrito|art[íi]culo|a[nñ]ad|agreg|enhorabuena|felic)(\s|$)/i.test(s)) return "es";
    if (/(^|\s)(korting|winkelwagen|voeg|artikel|gefelic)(\s|$)/i.test(s)) return "nl";
    if (/(^|\s)(reducere|coș|adauga|produs|felicit)(\s|$)/i.test(s)) return "ro";
    return "en";
  };

  const plPluralProdukt = (n) => {
    const nn = Math.abs(Number(n || 0));
    const last = nn % 10;
    const last2 = nn % 100;
    if (nn === 1) return "produkt";
    if (last >= 2 && last <= 4 && !(last2 >= 12 && last2 <= 14)) return "produkty";
    return "produktów";
  };

  const tpl = {
    pl: {
      have: (cur) => `Masz ${cur}% rabatu`,
      need: (n, next) => `Dodaj ${n} ${plPluralProdukt(n)}, aby mieć ${next}% zniżki`,
    },
    de: {
      have: (cur) => `Du hast ${cur}% Rabatt`,
      need: (n, next) => `Füge ${n} Artikel hinzu, um ${next}% Rabatt zu erhalten`,
    },
    en: {
      have: (cur) => `You have ${cur}% off`,
      need: (n, next) => `Add ${n} item${Number(n) === 1 ? "" : "s"} to get ${next}% off`,
    },
    es: {
      have: (cur) => `Tienes ${cur}% de descuento`,
      need: (n, next) => `Añade ${n} artículo${Number(n) === 1 ? "" : "s"} para obtener ${next}% de descuento`,
    },
    nl: {
      have: (cur) => `Je hebt ${cur}% korting`,
      need: (n, next) => `Voeg ${n} artikel${Number(n) === 1 ? "" : "en"} toe om ${next}% korting te krijgen`,
    },
    ro: {
      have: (cur) => `Ai ${cur}% reducere`,
      need: (n, next) => `Adaugă ${n} produs${Number(n) === 1 ? "" : "e"} pentru a obține ${next}% reducere`,
    },
  };

  const findPercents = (t) => {
    const out = [];
    const re = /(\d+(?:[.,]\d+)?)\s*%/g;
    let m;
    while ((m = re.exec(t))) out.push(m[1].replace(",", "."));
    return out;
  };

  const findCount = (t) => {
    const s = deParenS(norm(t)).toLowerCase();
    const re =
      /(\d+)\s+(?:więcej\s+)?(?:przedmiot(?:ów|y)?|produkt(?:ów|y)?|artyku(?:ł|ły|łów)?|artikel|item(?:s)?|article(?:s)?|art[íi]culo(?:s)?|producto(?:s)?|produs(?:e)?)\b/i;
    const m = s.match(re);
    return m ? m[1] : "1";
  };

  const isCongrats = (t) =>
    /(gratulacje|congrat|glückwunsch|enhorabuena|gefelic|felicit|felicidades)/i.test(t);

  const boldTailPercent = (plainRight) => {
    const s = norm(plainRight);
    if (!s) return "";
    const m = s.match(/^(.*?)(\s*\b\d+(?:[.,]\d+)?\s*%[^%]*)$/);
    if (!m) return esc(s);
    const head = m[1];
    const tail = m[2];
    return esc(head) + "<strong>" + esc(tail.trimStart()) + "</strong>";
  };

  const buildMsg = (raw) => {
    const t = norm(raw);
    if (!t) return { left: "", rightHtml: "" };

    const lang = detectLang(t);
    const perc = findPercents(t);
    const n = findCount(t);

    if (isCongrats(t) && perc.length >= 1) {
      return { left: t, rightHtml: "" };
    }

    if (perc.length >= 2) {
      const cur = perc[0];
      const next = perc[1];
      const rightPlain = tpl[lang].need(n, next);
      return { left: tpl[lang].have(cur), rightHtml: boldTailPercent(rightPlain) };
    }

    if (perc.length === 1) {
      const next = perc[0];
      const rightPlain = tpl[lang].need(n, next);
      return { left: tpl[lang].have("0"), rightHtml: boldTailPercent(rightPlain) };
    }

    const iDot = t.indexOf(". ");
    if (iDot > 0) {
      const left = norm(t.slice(0, iDot + 1));
      const rightPlain = norm(t.slice(iDot + 2));
      return { left, rightHtml: boldTailPercent(rightPlain) };
    }

    return { left: t, rightHtml: "" };
  };

  const build = (left, rightHtml) => {
    const wrap = document.createElement("div");
    wrap.id = ID;
    wrap.className = WRAP_CLASS;

    const l = document.createElement("span");
    l.className = LEFT_CLASS;
    l.innerHTML = esc(left);

    const icon = document.createElement("span"); // NEW
    icon.className = ICON_CLASS;
    icon.setAttribute("aria-hidden", "true");
    // icon.innerHTML = ""; // zostaw puste pod CSS ::before / background-image

    const r = document.createElement("span");
    r.className = RIGHT_CLASS;
    r.innerHTML = rightHtml || "";

    wrap.appendChild(l);
    wrap.appendChild(icon); // NEW
    wrap.appendChild(r);
    return wrap;
  };

  let isUpdating = false;

  const upsert = () => {
    if (isUpdating) return;

    const root = document.querySelector(ROOT_SEL);
    if (!root) return;

    const beforeEl = root.querySelector(INSERT_BEFORE_SEL);
    if (!beforeEl) return;

    const src = root.querySelector(SRC_SEL);
    if (!src) return;

    const raw = src.getAttribute("data-ea-raw") || src.textContent || "";
    const { left, rightHtml } = buildMsg(raw);

    const newL = esc(left);
    const newR = rightHtml || "";

    let out = root.querySelector("#" + ID);

    if (out) {
      const l = out.querySelector("." + LEFT_CLASS);
      const r = out.querySelector("." + RIGHT_CLASS);
      const sameText = l && r && l.innerHTML === newL && r.innerHTML === newR;
      const samePlace = out.nextSibling === beforeEl;
      if (sameText && samePlace) return;
    }

    isUpdating = true;
    try {
      if (!out) {
        out = build(left, rightHtml);
        beforeEl.parentNode.insertBefore(out, beforeEl);
      } else {
        const l = out.querySelector("." + LEFT_CLASS);
        const r = out.querySelector("." + RIGHT_CLASS);

        if (l && l.innerHTML !== newL) l.innerHTML = newL;
        if (r && r.innerHTML !== newR) r.innerHTML = newR;

        // icon zawsze istnieje po pierwszym build; jeśli masz stare w DOM bez icon:
        if (!out.querySelector("." + ICON_CLASS)) {
          const icon = document.createElement("span");
          icon.className = ICON_CLASS;
          icon.setAttribute("aria-hidden", "true");
          const rr = out.querySelector("." + RIGHT_CLASS);
          out.insertBefore(icon, rr || null);
        }

        if (out.nextSibling !== beforeEl) beforeEl.parentNode.insertBefore(out, beforeEl);
      }
    } finally {
      isUpdating = false;
    }
  };

  let scheduled = false;
  const scheduleUpsert = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      upsert();
    });
  };

  const boot = () => {
    scheduleUpsert();

    const root = document.querySelector(ROOT_SEL);
    if (!root) return;

    const mo = new MutationObserver((mutations) => {
      for (const m of mutations) {
        const t = m.target;
        if (t && t.nodeType === 1 && t.closest && t.closest("#" + ID)) return;

        if (m.addedNodes) for (const n of m.addedNodes) {
          if (n.nodeType === 1 && n.closest && n.closest("#" + ID)) return;
        }
        if (m.removedNodes) for (const n of m.removedNodes) {
          if (n.nodeType === 1 && n.closest && n.closest("#" + ID)) return;
        }
      }
      scheduleUpsert();
    });

    mo.observe(root, { subtree: true, childList: true, characterData: true, attributes: true });
    window.addEventListener("resize", scheduleUpsert, { passive: true });
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot, { once: true });
  } else {
    boot();
  }
})();